<template>
  <div>
    <div v-if="service">
      <div
        data-ix="hide-fixed-top-wrapper"
        class="w-hidden-small w-hidden-tiny fixed-block-top-wrapper"
      >
        <div class="w-container container with-fixed-block">
          <div class="fixed-block-wrapper">
            <a
              href="#"
              data-ix="close-fixed-bar"
              class="w-inline-block fixed-block-close-button"
            >
              <img
                src="/images/Icon-close-thin.png"
                class="close-icon"
              >
            </a>
            <Sidebar />
          </div>
        </div>
      </div>
      <Navbar />
      <div class="w-section page-header services">
        <div
          data-ix="navbar-grow"
          class="page-header-overlay services"
        >
          <div class="w-container container">
            <h1
              data-ix="fade-in-on-load"
              class="page-header-title"
            >
              {{ service.title }}
            </h1>
          </div>
        </div>
      </div>
      <div class="w-section section">
        <div class="w-container container home-intro-container">
          <div class="w-row home-intro-row">
            <div class="w-col w-col-6 home-intro-column">
              <div class="w-clearfix home-intro-block services-block">
                <img
                  data-ix="fade-in-on-load-2"
                  class="intro-block-icon"
                >
                <div
                  data-ix="fade-in-on-load-2"
                  class="intro-block-title"
                >
                  Our service
                </div>
                <p data-ix="fade-in-on-load-2">
                  {{ service.description }}
                </p>
              </div>
            </div>
            <div class="w-col w-col-6 home-intro-column">
              <div class="home-intro-block services-block last">
                <div
                  data-ix="fade-in-on-load-3"
                  class="intro-block-title"
                >
                  What we do
                </div>
                <ul
                  data-ix="fade-in-on-load-3"
                  class="w-list-unstyled services-list"
                >
                  <li
                    v-for="(item, index) in service.what_we_do"
                    :key="index"
                    class="services-list-item"
                  >
                    <img
                      src="/images/Icon-check-black.png"
                      class="check-list-icon"
                    >
                    <div class="service-description-small">
                      {{ item }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="w-container container with-fixed-block">
          <div class="dynamic-item-wrapper">
            <div
              class="w-richtext"
              v-html="compiledMarkdown"
            >
              {{ compiledMarkdown }}
            </div>
          </div>
          <div class="project-examples-wrapper">
            <div class="work-block-title">
              Example projects:
            </div>
            <div class="w-dyn-list">
              <div
                v-if="projects && projects.length > 0"
                class="w-dyn-items w-row w-clearfix portfolio-list examples"
              >
                <ProjectItem
                  v-for="project in projects"
                  :key="project.id"
                  :project="project"
                />
              </div>
              <div
                v-else
                class="w-dyn-empty portfolio-empty-block"
              >
                <p>Sorry, no items found in this category.</p>
              </div>
            </div>
            <p>
              Want to see more?&nbsp;
              <router-link
                class="link"
                :to="{ name: 'Portfolio' }"
              >
                View full portfolio
              </router-link>
            </p>
          </div>
          <div
            data-ix="show-fixed-block"
            class="fixed-block-container-wrapper"
          >
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Navbar from '@/components/TheNavbar'
import Sidebar from '@/components/TheSidebar'
// import Footer from '@/components/TheFooter';
import ProjectItem from '@/components/ProjectItemSmall'

export default {
  name: 'ServiceDetail',

  components: {
    Navbar,
    Sidebar,
    // Footer,
    ProjectItem,
  },

  props: {
    slug: {
      required: true,
      type: String,
    },
  },

  computed: {
    ...mapGetters(['getServiceBySlug', 'getProjectsById']),
    service() {
      return this.getServiceBySlug(this.slug)
    },
    projects() {
      return this.getProjectsById([1])
    },
    compiledMarkdown() {
      return this.getMardownFile(this.service.content)
    },
  },

  created() {
    this.fetchServices()
    this.fetchProjects()
  },

  mounted() {
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 10)
  },

  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },

  methods: {
    ...mapActions(['fetchServices', 'fetchProjects']),
    getMardownFile(filename) {
      // eslint-disable-next-line
      return require(`../data/services/${filename}`)
    },
  },
}
</script>
